import hasAccruedReports from './utilities/hasAccruedReports';
import hasCapitalizedFields from './utilities/hasCapitalizedFields';
import hasFullName from './utilities/hasFullName';
import hasRemedials from './utilities/hasRemedials';

const trainingPhase = (trainingPhaseJson) => {
  const getHasAccrued = (type) => {
    return trainingPhaseJson.attributes.accrued.find((report) => {
      return report.type === type;
    });
  };
  const hasOpenRemedial = !!trainingPhaseJson.attributes.remedials.find((remedial) => {
    return remedial.status !== 'completed';
  });
  const properties = {
    ...trainingPhaseJson.attributes,
    guid: trainingPhaseJson.guid,
    hasOpenRemedial,
  };
  const methods = {
    getCanAddReports() {
      return trainingPhaseJson.attributes.type === 'observation'
        && !trainingPhaseJson.attributes.fto;
    },
    getCanAssignFto() {
      return trainingPhaseJson.attributes.type === 'observation'
        && !trainingPhaseJson.attributes.fto;
    },
    getCanPhaseClose() {
      switch (trainingPhaseJson.attributes.type) {
        case 'observation':
          return (
            trainingPhaseJson.attributes.status === 'opened'
              && !hasOpenRemedial && getHasAccrued('eop')
          );
        case 'orientation':
          return (
            trainingPhaseJson.attributes.status === 'opened' &&
            (getHasAccrued('tpo') || getHasAccrued('eop'))
          );
        default:
          return true;
      }
    },
    getFtoFullName() {
      return !trainingPhaseJson.attributes.fto ? null
        : `${trainingPhaseJson.attributes.fto.firstName} ${trainingPhaseJson.attributes.fto.lastName}`;
    },
    getHasAccrued,
    getIsPhaseOpened() {
      return trainingPhaseJson.attributes.status === 'opened'
        || trainingPhaseJson.attributes.status === 'remedial';
    },
  };
  return Object.assign(
    properties,
    methods,
    hasAccruedReports(trainingPhaseJson.attributes.accrued),
    hasCapitalizedFields(trainingPhaseJson.attributes),
    hasFullName(trainingPhaseJson.attributes, 'oit'),
    hasRemedials(trainingPhaseJson.attributes.remedials),
  );
};

export default trainingPhase;

//todo improve trainingPhase() so it can use included training phases from ot
const trainingPhaseFromIncluded = (trainingPhaseJson) => {
  const getHasAccrued = (type) => {
    return trainingPhaseJson.accrued.find((report) => {
      return report.type === type;
    });
  };
  const hasOpenRemedial = !!trainingPhaseJson.remedials.find((remedial) => {
    return remedial.status !== 'completed';
  });
  const properties = {
    ...trainingPhaseJson,
    guid: trainingPhaseJson.guid,
    hasOpenRemedial,
  };
  const methods = {
    getCanAddReports() {
      return trainingPhaseJson.type === 'observation'
        && !trainingPhaseJson.fto;
    },
    getCanAssignFto() {
      return trainingPhaseJson.type === 'observation'
        && !trainingPhaseJson.fto;
    },
    getCanPhaseClose() {
      switch (trainingPhaseJson.type) {
        case 'observation':
          return (
            trainingPhaseJson.status === 'opened'
            && !hasOpenRemedial && getHasAccrued('eop')
          );
        case 'orientation':
          return (
            trainingPhaseJson.status === 'opened' &&
            (getHasAccrued('tpo') || getHasAccrued('eop'))
          );
        default:
          return true;
      }
    },
    getFtoFullName() {
      return !trainingPhaseJson.fto ? null
        : `${trainingPhaseJson.fto.firstName} ${trainingPhaseJson.fto.lastName}`;
    },
    getHasAccrued,
    getIsPhaseOpened() {
      return trainingPhaseJson.status === 'opened'
        || trainingPhaseJson.status === 'remedial';
    },
  };
  return Object.assign(
    properties,
    methods,
    hasAccruedReports(trainingPhaseJson.accrued),
    hasCapitalizedFields(trainingPhaseJson),
    hasFullName(trainingPhaseJson, 'oit'),
    hasRemedials(trainingPhaseJson.remedials),
  );
};

export {
  trainingPhaseFromIncluded
}